import { createClient } from '@reservoir0x/reservoir-sdk';
import { configs } from '@/configs';

export const ReservoirClient = createClient({
  apiBase: configs.reservoirApiUrl,
  apiKey: configs.reservoirApiKey,
  source: 'universe.xyz',
});